import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderConfigurationQuery,
   CurrentHealthcareProviderConfigurationSetCommand,
} from '@dreryk/egabinet-patient-portal-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionBar, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import {
   formBeanToRequestsForAppointmentConfiguration,
   formBeanToSlotBookingLeadPeriod,
} from '../healthcareProviderPatientPortalSettings/AppointmentRequestsSettingsForm/AppointmentRequestsSettingsForm.utils';
import { formBeanToPreInterviewConfiguration } from '../preInterviewSettings/form/PreInterviewSettingsForm.utils';
import { settingsTranslationKeys } from '../../translations';

import {
   HealthcareProviderConfigurationFormBean,
   HealthcareProviderConfigurationFormController,
} from './HealthcareProviderConfigurationForm.types';

const t = settingsTranslationKeys;

type HealthcareProviderConfigurationSaveButtonProps = Readonly<{
   handleSubmit: HealthcareProviderConfigurationFormController['handleSubmit'];
}>;

export const HealthcareProviderConfigurationSaveButton = (
   props: HealthcareProviderConfigurationSaveButtonProps
): ReactElement => {
   const { executeAsync: saveConfiguration } = useCqrsCommand<void, HealthcareProviderConfigurationFormBean>(
      (parameters) => {
         const command = new CurrentHealthcareProviderConfigurationSetCommand();
         // TODO DRPAC-1375 Zdjęcie flagi eksperymentalnej z konfiguracji prewywiadu
         command.preInterviewConfiguration = protectFeature(
            'experimental',
            formBeanToPreInterviewConfiguration(parameters)
         );
         command.requestsForAppointmentConfiguration = formBeanToRequestsForAppointmentConfiguration(parameters);
         command.slotBookingLeadPeriod = formBeanToSlotBookingLeadPeriod(parameters);
         return command;
      },
      {
         onSuccess: (_result, parameters) => {
            dispatchSnackbarPositiveEvent(t.changesSaved);
            if (!parameters.allowAppointmentRequests) {
               refetchCqrsQuery(CurrentHealthcareProviderConfigurationQuery);
            }
         },
      }
   );

   return (
      <ActionBar.PrimaryButton
         testId={'appointmentRequestsSave'}
         label={t.save}
         onClick={props.handleSubmit(saveConfiguration)}
         variant={ButtonVariant.PRIMARY}
         blockingOperation
      />
   );
};
